import type { PublisherDetail } from '@planuze/admin-contracts';
import { fmtDurationMs } from '../../lib/format.js';
import type { SummaryMetric } from '../detail-summary.js';

/* Faixa-resumo do detalhe do publisher (ADR-0707): condensa os stats de moderação já carregados
   (`publisherWithStatsDto`) + as contagens derivadas das chaves numa linha escaneável, para não
   deixar tudo escondido nas abas Moderação/Chaves. Puro — testável sem router/hooks. */

const PERCENT = 100;
const PLACEHOLDER = '—';

export function buildPublisherSummaryMetrics(publisher: PublisherDetail): SummaryMetric[] {
  const stats = publisher.stats ?? null;
  const avgReviewMs = stats?.avgReviewMs ?? null;
  const rootSigned = publisher.keys.filter((key) => key.rootSigned).length;
  const revoked = publisher.keys.filter((key) => key.revoked).length;

  return [
    { label: 'Submissões', value: stats?.totalSubmissions ?? 0 },
    { label: 'Pendentes', value: stats?.pendingSubmissions ?? 0 },
    {
      label: 'Taxa de rejeição',
      value: stats === null ? PLACEHOLDER : `${Math.round(stats.rejectionRate * PERCENT)}%`,
    },
    {
      label: 'Tempo médio',
      value: avgReviewMs === null ? PLACEHOLDER : fmtDurationMs(avgReviewMs),
      hint: 'de revisão',
    },
    { label: 'Chaves', value: publisher.keys.length },
    { label: 'Root-assinadas', value: rootSigned },
    { label: 'Revogadas', value: revoked },
  ];
}
